import classnames from 'classnames';
import React from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import { CompanyMembership, ExtendedContact } from '@/types';

import FirstDegreeContact from './components/first-degree-contact';
import SecondDegreeContact from './components/second-degree-contact';
import { FORMER } from './constants/companyMembership';

import styles from './company-contact.css';

type Props = {
  className?: string;
  company: string;
  companyMembership: CompanyMembership;
  connectionDegree: number;
  contact?: ExtendedContact;
  displayHint?: boolean;
};

const CompanyContact: React.FC<Props & WrappedComponentProps> = ({
  contact,
  company,
  connectionDegree = contact?.user?.connectionDegree,
  companyMembership = contact?.companyMembership,
  intl,
  className,
  displayHint = true,
}) => {
  const contactType = connectionDegree === 1 ? `first_${(companyMembership || 'undefined').toLowerCase()}` : 'second';
  const hint = displayHint
    ? intl.formatMessage(
        {
          id: `JOBS_DETAIL_COMPANY_CONTACT_${companyMembership === FORMER ? 'PREVIOUS' : 'CURRENT'}_COMPANY`,
        },
        { company }
      )
    : null;

  return (
    <div
      className={classnames(className, styles.companyContact)}
      data-testid="company-contact"
      data-testcompanycontacttype={contactType}
    >
      {connectionDegree === 1 ? (
        <FirstDegreeContact
          user={contact?.user}
          hint={hint}
          messengerContextId={`jobs_contact_${companyMembership === FORMER ? 'former' : 'current'}_employee`}
          entryPoint="jobs_job_detail_contact"
        />
      ) : (
        <SecondDegreeContact contact={contact} hint={hint} />
      )}
    </div>
  );
};

export default injectIntl(CompanyContact);
